module.exports = __webpack_public_path__ + "img/eyemask.6d001ff6.png";